// removed by extract-text-webpack-plugin
module.exports = {"selectedVehicles":"SelectionSummary-hashed__selectedVehicles__3ZFnE","summaryList":"SelectionSummary-hashed__summaryList__KE3zo","row":"SelectionSummary-hashed__row__2Qjyo","deleteIcon":"SelectionSummary-hashed__deleteIcon__1eH28","summaryHeader":"SelectionSummary-hashed__summaryHeader__2FYDW","summaryContainer":"SelectionSummary-hashed__summaryContainer__3jDUB","summaryFooter":"SelectionSummary-hashed__summaryFooter__3-zxD"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/components/SelectionSummary/SelectionSummary-hashed.scss
// module id = 1162
// module chunks = 0